import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationGuardService } from './@core/auth/auth-guard.service';
import { FullComponent } from './layouts/full/full.component';


export const routes: Routes = [
	{
		path: '',
		component: FullComponent,
		children: [
			{
				path: 'dashboard',
				loadChildren: './backoffice/dashboard/dashboard.module#DashboardModule'
			},
			{
				path: 'lhdashboard',
				loadChildren: './backoffice/linehaul-dashboard/linehaul-dashboard.module#LinehaulDashboardModule'
			},
			{
				path: 'onroute-connect',
				loadChildren: './backoffice/onroute-connect/onroute-connect.module#OnrouteConnectModule'
			},
			{
				path: 'admin',
				loadChildren: './backoffice/admin/admin.module#AdminModule'
			},
			{
				path: 'staff',
				loadChildren: './backoffice/staff/staff.module#StaffModule'
			},
			{
				path: 'dispatch',
				loadChildren: './backoffice/dispatch/dispatch.module#DispatchModule'
			},
			{
				path: 'linehaul',
				loadChildren: './backoffice/linehaul/linehaul.module#LinehaulModule'
			},
			{
				path: 'fleet',
				loadChildren: './backoffice/fleet/fleet.module#FleetModule'
			},
			{
				path: 'conf',
				loadChildren: './backoffice/configuration/configuration.module#ConfigurationModule'
			},
			{
				path: 'control-room',
				loadChildren: './backoffice/control-room/control-room.module#ControlRoomModule'
			},
			{
				path: 'planner',
				loadChildren: './backoffice/planner/planner.module#PlannerModule',
				data: {
					section: 'routesimulation'
				}
			},
			{
				path: 'reporting',
				loadChildren: './backoffice/reporting/reporting.module#ReportingModule',
				data: {
					section: 'reporting'
				}
			},
			{
				path: 'hive',
				loadChildren: './hive/hive.module#HiveModule'
			},
			{
				path: 'unauthorized',
				loadChildren: './unauthorized/unauthorized.module#UnauthorizedModule'
			}
		],
		canActivate: [AuthenticationGuardService],
		canActivateChild: [AuthenticationGuardService]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: false }), NgbModule.forRoot()],
	exports: [RouterModule]
})
export class AppRoutingModule {}
